import { render, staticRenderFns } from "./NuevaSolicitud.vue?vue&type=template&id=9925f0a2&"
import script from "./NuevaSolicitud.vue?vue&type=script&lang=ts&"
export * from "./NuevaSolicitud.vue?vue&type=script&lang=ts&"
import style0 from "./NuevaSolicitud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9925f0a2', component.options)
    } else {
      api.reload('9925f0a2', component.options)
    }
    module.hot.accept("./NuevaSolicitud.vue?vue&type=template&id=9925f0a2&", function () {
      api.rerender('9925f0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/NuevaSolicitud/NuevaSolicitud.vue"
export default component.exports